module.exports = __webpack_public_path__ + "1d8d5ac339b326c3e26a893b60c56a6f.svg";